import type { EdgeId } from '@ipfabric/utils';
import {
  deviceViewPacketDetailsEntityId,
  isPacketDetailsEntity,
} from 'components/DeviceView/deviceViewTypes';
import type { DeviceViewCommandFactory } from '../DeviceViewModel';

interface HidePathLookupDetailAnimationCommand {
  detailId: EdgeId;
}

export const hidePathLookupDetailAnimation: DeviceViewCommandFactory<
  HidePathLookupDetailAnimationCommand
> = (cmdContext) => (command) => {
  cmdContext.updateState((draft) => {
    const foundEntity = draft.deviceViewEntities.find(
      (entity) => entity.id === deviceViewPacketDetailsEntityId,
    );
    if (foundEntity !== undefined && isPacketDetailsEntity(foundEntity)) {
      const foundDetail = foundEntity.details.find(
        (detail) => detail.id === command.detailId,
      );
      if (foundDetail !== undefined) {
        foundDetail.showAnimation = false;
      }
    }
  });
};
